import { createFileRoute } from '@tanstack/react-router';
import { PageShell } from '~/components/layout';
import {
  CtaBanner,
  DownloadQr,
  FaqAccordion,
  FeatureBlock,
  Hero,
  QuoteTestimonials,
  TestimonialGrid,
  TextSection,
} from '~/components/sections';
import { cardsControl, cardsHero, cardsPayInATap, cardsSpend } from '~/content/cards';
import { trustedBySection } from '~/content/shared';
import { getTestimonials } from '~/lib/payload';
import { pageHeadMeta } from '~/lib/seo';
import heroCss from '~/styles/hero.css?inline';

export const Route = createFileRoute('/cards')({
  loader: () => getTestimonials({ data: 'cards' }),
  head: () =>
    pageHeadMeta({
      title: 'Get a Virtual Debit Card for Online and Global Payments',
      description:
        'Get a virtual debit card in minutes. Create a secure digital card for online payments, subscriptions like Netflix and Figma, and pay with Google Pay and more.',
      path: '/cards',
      inlineStyles: [heroCss],
    }),
  component: CardsPage,
});

function CardsPage() {
  const quotes = Route.useLoaderData();
  // Only pad short lists for a fuller horizontal scroll. When the page filter
  // returns a full unique set (4+), pass it through so the carousel doesn't
  // look like two comments looping forever.
  const carouselQuotes =
    quotes.length > 0 && quotes.length < 4
      ? Array.from({ length: 10 }, (_, i) => quotes[i % quotes.length]!)
      : quotes;

  return (
    <PageShell>
      <Hero content={cardsHero} />
      <TextSection content={trustedBySection} />
      <FeatureBlock content={cardsSpend} imagePosition="left" />
      <FeatureBlock content={cardsPayInATap} imagePosition="right" ctaSlot={<DownloadQr />} />
      <FeatureBlock content={cardsControl} imagePosition="left" />
      <QuoteTestimonials
        title="Trusted by users around the globe"
        quotes={carouselQuotes}
        className="!py-[200px]"
      />
      <TestimonialGrid />
      <FaqAccordion />
      <CtaBanner />
    </PageShell>
  );
}
